import React from "react";
import PropTypes from "prop-types";
import c from "classnames";
import objectPath from "object-path";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {FormattedMessage} from "react-intl";
import ProgressBar from "~/components/ProgressBar";
import styles from "./match-list.module.scss";
import Checkbox from "~/components/Checkbox";
import uuid from "uuid/v4";

export default class Match extends React.PureComponent {
    static propTypes = {
        match: PropTypes.shape({
            id: PropTypes.string.isRequired,
            score: PropTypes.number.isRequired,
            details: PropTypes.object.isRequired,
            explanations: PropTypes.array,
        }).isRequired,
        extraColumns: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                property: PropTypes.string.isRequired,
            })
        ),
        isSelected: PropTypes.bool.isRequired,
        isFixedSelected: PropTypes.bool.isRequired,
        allowSelection: PropTypes.bool.isRequired,
        renderDetailsColumn: PropTypes.func.isRequired,
        renderMatchActions: PropTypes.func.isRequired,
        extraColumnPropertyRoot: PropTypes.func.isRequired,
        isGreenMatch: PropTypes.func.isRequired,
        onView: PropTypes.func.isRequired,
        onSelectedChange: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            isShowingInfo: false,
        };

        this.id = uuid();
    }

    render() {
        const {
            match,
            allowSelection,
            isSelected,
            isFixedSelected,
            extraColumns,
            renderDetailsColumn,
            renderMatchActions,
            extraColumnPropertyRoot,
            isGreenMatch,
        } = this.props;

        return (
            <tr className={c({[styles.selectable]: allowSelection})} onClick={this.toggleSelected}>
                {allowSelection && (
                    <td className={styles.selectionColumn}>
                        <Checkbox
                            checked={isSelected || isFixedSelected}
                            onChange={this.handleSelectedChange}
                            disabled={isFixedSelected}
                        />
                    </td>
                )}
                <td className={styles.relevanceColumn}>
                    <OverlayTrigger
                        placement="right"
                        delay={{show: 250, hide: 400}}
                        overlay={this.renderTooltip}
                    >
                        <ProgressBar
                            className={styles.progress}
                            variant={isGreenMatch(match) ? "success" : "warning"}
                            now={match.score}
                            min={0}
                            max={1}
                        />
                    </OverlayTrigger>
                </td>
                <td className={styles.detailsColumn}>{renderDetailsColumn(match)}</td>
                {extraColumns &&
                    extraColumns.map(extraColumn => (
                        <td key={extraColumn.property}>
                            {objectPath.get(extraColumnPropertyRoot(match), extraColumn.property)}
                        </td>
                    ))}
                <td className={c(styles.contextToggleColumn, "text-nowrap")}>
                    <button
                        className={c("btn", "btn-sm", "btn-info")}
                        onClick={this.handleViewClick}
                    >
                        <FormattedMessage id="match.details" />
                    </button>
                    {renderMatchActions(match)}
                </td>
            </tr>
        );
    }

    renderTooltip = props => {
        const {match, isGreenMatch} = this.props;

        return (
            <Tooltip id={this.id} {...props} show={props.show.toString()}>
                <FormattedMessage
                    id={isGreenMatch(match) ? "resultTooltip.green" : "resultTooltip.yellow"}
                />
            </Tooltip>
        );
    };

    handleViewClick = e => {
        const {match, onView} = this.props;
        e.preventDefault();
        e.stopPropagation();
        onView(match.id);
    };

    toggleSelected = () => {
        const {allowSelection, isSelected, match, onSelectedChange, isFixedSelected} = this.props;
        if (!allowSelection || isFixedSelected) return;
        onSelectedChange(match.id, !isSelected);
    };

    handleSelectedChange = selected => {
        const {match, onSelectedChange} = this.props;
        onSelectedChange(match.id, selected);
    };
}
